// Claude 2026-09-24 · Load 3 "Save your genres" bar + genre signals for Meta retargeting.
// Owner decisions: no popup, no incentive, fades in slowly under the picker, numbers visible in the admin.
// Shopify customer events published here (a custom pixel forwards them to Meta, see integrations/meta-genre-pixel.js):
//   bs_genres_selected {genres[], genre_count, source}   bs_genres_saved {genres[], genre_count}
const bar = document.querySelector('[data-bsg]');
const store = {
  get: (k) => { try { return localStorage.getItem(k); } catch { return null; } },
  set: (k, v) => { try { localStorage.setItem(k, v); } catch { /* private mode */ } },
};
const publish = (name, data) => { try { window.Shopify?.analytics?.publish?.(name, data); } catch { /* analytics never breaks the page */ } };
const picked = () => [...document.querySelectorAll('[data-bp-genre][aria-pressed="true"]')].map((b) => b.dataset.bpGenre);

// ---------- genre signals (independent of the bar) ----------
let lastSent = '', sigTimer, surpriseAt = 0;
document.addEventListener('bookscription:surprise', () => { surpriseAt = Date.now(); });
function signal(genres) {
  clearTimeout(sigTimer);
  sigTimer = setTimeout(() => {
    const key = genres.slice().sort().join('|');
    if (!genres.length || key === lastSent) return;
    lastSent = key;
    const source = Date.now() - surpriseAt < 8000 ? 'surprise' : (document.querySelector('[data-bp-product]')?.dataset.bpGenreSource || 'picker');
    publish('bs_genres_selected', { genres, genre_count: genres.length, source });
  }, 1500);
}

if (bar) initBar(bar);
else document.addEventListener('bp:selection-change', (e) => signal(e.detail?.genres ?? picked()));

function initBar(bar) {
  const api = `${bar.dataset.bsgApi.replace(/\/$/, '')}/bs-capture`;
  const min = Number(bar.dataset.bsgMin) || 4;
  const msg = bar.querySelector('[data-bsg-msg]'), save = bar.querySelector('[data-bsg-save]');
  const params = new URLSearchParams(location.search);
  const force = params.get('bs_bar') === '1';
  const sid = (() => {
    try { let s = sessionStorage.getItem('bs_sid'); if (!s) { s = crypto.randomUUID(); sessionStorage.setItem('bs_sid', s); } return s; }
    catch { return (crypto.randomUUID?.() ?? String(Math.random()).slice(2)); }
  })();
  const utm = {};
  for (const k of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid']) if (params.get(k)) utm[k] = params.get(k).slice(0, 120);
  const dismissed = Date.now() - Number(store.get('bs_bar_dismissed') || 0) < 30 * 864e5;
  const blocked = !force && (store.get('bs_saved_email') === '1' || dismissed);

  // text/plain keeps these as "simple" requests (no CORS preflight); the function parses JSON from text.
  const send = (payload, beacon = false) => {
    const body = JSON.stringify(payload);
    if (beacon && navigator.sendBeacon && navigator.sendBeacon(api, new Blob([body], { type: 'text/plain' }))) return Promise.resolve(null);
    return fetch(api, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body, keepalive: beacon });
  };

  let shown = false, timer;
  function show() {
    if (shown) return;
    shown = true; bar.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => bar.classList.add('is-in')));
    const io = new IntersectionObserver((entries) => {
      if (entries.some((x) => x.isIntersecting)) { io.disconnect(); send({ action: 'event', event: 'view', sid, page: location.pathname, count: picked().length }, true); }
    }, { threshold: 0.6 });
    io.observe(bar);
  }
  function consider(count) {
    if (blocked || shown || count < 1) return;
    clearTimeout(timer);
    // Slow and calm: wait for a pause in picking (sooner once the minimum is reached).
    timer = setTimeout(show, count >= min ? 1200 : 3500);
  }
  function hide() { bar.classList.add('is-out'); setTimeout(() => { bar.hidden = true; }, 520); }

  document.addEventListener('bp:selection-change', (e) => { const g = e.detail?.genres ?? picked(); signal(g); consider(g.length); });
  if (picked().length) { signal(picked()); consider(picked().length); }
  if (force) setTimeout(show, 600);

  bar.querySelector('[data-bsg-close]').addEventListener('click', () => {
    store.set('bs_bar_dismissed', String(Date.now()));
    send({ action: 'event', event: 'dismiss', sid, page: location.pathname, count: picked().length }, true);
    hide();
  });

  const emailInput = bar.querySelector('[data-bsg-email]'), hp = bar.querySelector('[data-bsg-hp]');
  emailInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); save.click(); } }); // never submit the add-to-bag form
  save.addEventListener('click', async () => {
    const email = emailInput.value.trim();
    const genres = picked();
    const say = (t, bad = false) => { msg.textContent = t; msg.hidden = false; msg.classList.toggle('is-error', bad); };
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return say('That email doesn’t look right. Try again?', true);
    if (!genres.length) return say('Pick at least one genre first, then save.', true);
    save.setAttribute('aria-busy', 'true'); save.disabled = true;
    try {
      const res = await send({ action: 'save', email, genres, consent: true, sid, page: location.pathname, product: bar.dataset.bsgProduct, utm, company: hp.value });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(d.error || 'Couldn’t save right now. Please try again.');
      store.set('bs_saved_email', '1');
      store.set('bs_saved_genres', JSON.stringify(genres));
      bar.classList.add('is-saved');
      say(d.message || 'Saved! Your picks will be waiting when you come back.');
      publish('bs_genres_saved', { genres, genre_count: genres.length });
      setTimeout(hide, 7000);
    } catch (err) { say(err.message, true); }
    finally { save.removeAttribute('aria-busy'); save.disabled = false; }
  });
}
